import React, { useEffect, useState } from "react";
import Navstyles from "./nav.module.css";
import { menuItems } from "./config";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Logo from "../../Assets/KohereHedaer.png";
import useStore from "../../Store";
import { MdLogout } from "react-icons/md";
import Logoblue from "../../Assets/login/blue-logo.svg";
import styles from "../../pages/Dashboard/Dashboard.module.css";
import { FaSearch, FaFilter } from "react-icons/fa";
import { RotatingLines } from "react-loader-spinner";
import { searchCompanies, create_companies } from "../../Services/APIrequests";
import AdvanceSearch from "../Navbar/advanceSearch";
const Navbar = ({ Active }) => {
    const location = useLocation();
    // console.log("Current Path:", location.pathname);
    const { CIN, setCIN } = useStore();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [companyData, setCompanyData] = useState(null);
    const [companies, setCompanies] = useState([]);
    const [status, setStatus] = useState(1);
    const [isSearchable, setIsSearchable] = useState(true);
    const [AdvanceSearchOpen, setAdvanceSearchOpen] = useState(false);
    const { Theme, setTheme } = useStore();
    const [searchType, setSearchType] = useState("NAME");
    const [searchTerm, setSearchTerm] = useState("");
    const [error, setError] = useState(null);
    const popupRef = React.useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setShowPopup(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSearchTypeChange = (event) => {
        setSearchType(event.target.value);
        setSearchTerm("");
    };

    const handleInputChange = (event) => {
        setIsSearchable(true);
        // setSearchTerm(event.target.value);
        // if (event.target.value.trim() === "") {
        //   setShowPopup(false);
        // }
        const value = event.target.value;
        setSearchTerm(value);

        if (value.trim() !== "") {
            setLoading(true);
            setShowPopup(true);
        } else {
            setShowPopup(false);
            setLoading(false);
        }
    };
    const handleCompanyClick = (cin, name) => {
        setIsSearchable(false);
        setSearchTerm("");
        setCIN(cin);
        fetchCompanyData(cin);
    };
    const handleNavigate = (menuLink) => {
        const token = sessionStorage.getItem("token");
        if (menuLink === "/kohere/Companydetails") {
            if (CIN) {
                navigate(`${menuLink}/${CIN}`);
            }
        } else if (
            menuLink === "/kohere/mykohere" ||
            menuLink === "/kohere/Dashboard" ||
            menuLink === "/kohere/mycredits" ||
            menuLink === "/kohere/mybusinessforsale"
        ) {
            if (!token) {
                navigate("/login", { state: { from: location.pathname } });
            } else {
                navigate(menuLink);
            }
        } else {
            navigate(menuLink);
        }
    };
    const handleLogout = () => {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("activeTab");
        navigate("/");
    };
    const fetchCompanyData = async (cin) => {
        setLoading(true);
        setError(null);

        try {
            const params = new URLSearchParams();
            if (status === 1) {
                params.append("aboutTheCompany", "true");
            } else if (status === 2) {
                params.append("directors", "true");
            }

            const res = await create_companies(cin, params);
            if (res.status === 200) {
                setCompanyData(res.data);
                setShowPopup(false);
                navigate(`/kohere/Companydetails/${cin}?status=1`);
            } else {
                setError("Failed to fetch company data");
            }
        } catch (err) {
            setError("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };
    // Debounced search for companies
    useEffect(() => {
        const debounceTimeout = setTimeout(() => {
            if (searchTerm) {
                searchHandler();
            }
        }, 500);

        return () => clearTimeout(debounceTimeout);
    }, [searchTerm]);

    // Close AdvanceSearch on Escape key
    useEffect(() => {
        if (!AdvanceSearchOpen) return;
        const handleKey = (e) => {
            if (e.key === "Escape") {
                setAdvanceSearchOpen(false);
            }
        };
        document.addEventListener("keydown", handleKey);
        return () => document.removeEventListener("keydown", handleKey);
    }, [AdvanceSearchOpen]);

    // lock body scroll when advance search is open
    useEffect(() => {
        if (AdvanceSearchOpen) {
            // save current overflow
            const prev = document.body.style.overflow;
            document.body.style.overflow = "hidden";
            return () => {
                document.body.style.overflow = prev || "";
            };
        }
    }, [AdvanceSearchOpen]);

    // (body scroll lock effect above handles preventing body scroll when popup is open)

    const searchHandler = async () => {
        if (searchTerm.trim().length < 1) {
            setCompanies([]);
            setShowPopup(false);
            return;
        }
        if (!isSearchable) {
            setIsSearchable(true);
        }

        setLoading(true);
        setError(null);
        try {
            const queryParam =
                searchType === "NAME"
                    ? { name: searchTerm }
                    : { id: searchTerm };

            const response = await searchCompanies(queryParam);

            if (response.status === 200) {
                setCompanies(response.data.companies || []);
                setStatus(response.data.Status);
            } else {
                setCompanies([]);
            }
        } catch (err) {
            setError("Companies Not Found");
        } finally {
            setLoading(false);
            setShowPopup(true);
        }
    };
    return (
        <div className={Navstyles.MainNav}>
            <div className={Navstyles.header}>
                <div className={Navstyles.leftnav}>
                    <div className={Navstyles.imagecontainer}>
                        <Link to="/">
                            <img
                                src={Theme === "dark" ? Logo : Logoblue}
                                alt="logo"
                                className={Navstyles.img}
                            />
                        </Link>
                    </div>
                </div>
                <div className={Navstyles.searchbar} ref={popupRef}>
                    <div className={styles.searchContainer}>
                        <div className={styles.searchBox}>
                            <FaSearch className={styles.searchIcon} />
                            <input
                                className={styles.searchInput}
                                type="text"
                                placeholder={`Search by ${searchType === "NAME" ? "name" : "CIN"
                                    }`}
                                value={searchTerm}
                                onChange={handleInputChange}
                            />
                            <div className={styles.searchFilter}>
                                {/* <FaFilter className={styles.filterIcon} /> */}
                                <select
                                    className={styles["view_search"]}
                                    value={searchType}
                                    onChange={handleSearchTypeChange}>
                                    <option value={"NAME"}>NAME</option>
                                    <option value={"UID"}>CIN</option>
                                </select>
                                <button
                                    type="button"
                                    className={styles["advancebutton"]}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setAdvanceSearchOpen((p) => !p);
                                    }}>
                                    <FaFilter />
                                </button>
                            </div>
                            {/* Advance Search popup anchored to the input */}
                            {AdvanceSearchOpen && (
                                <>
                                    {/* Backdrop covers the screen and closes the popup when clicked */}
                                    <div
                                        className={styles.backdrop}
                                        onClick={() =>
                                            setAdvanceSearchOpen(false)
                                        }
                                    />

                                    <div
                                        className={styles.advanceSearchWrapper}
                                        onClick={(e) => e.stopPropagation()}>
                                        <AdvanceSearch
                                            setAdvanceSearchOpen={
                                                setAdvanceSearchOpen
                                            }
                                            inline={true}
                                            onClose={() =>
                                                setAdvanceSearchOpen(false)
                                            }
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className={styles.searchcompanynames}>
                        {showPopup && (
                            <div className={styles.popup}>
                                <div className={styles.popupContent}>
                                    {error && <p>{error}</p>}
                                    {!error && (
                                        <ul
                                            className={styles.companyList}
                                            style={{ zIndex: 10000 }}>
                                            {loading && (
                                                <li
                                                    style={{
                                                        listStyle: "none",
                                                    }}>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent:
                                                                "center",
                                                            alignItems:
                                                                "center",
                                                            padding: "20px 0",
                                                        }}>
                                                        <RotatingLines
                                                            height="40"
                                                            width="40"
                                                            color="#4fa94d"
                                                            ariaLabel="loading"
                                                            visible={true}
                                                        />
                                                    </div>
                                                </li>
                                            )}

                                            {!loading &&
                                                !error &&
                                                companies.length > 0 && (
                                                    <>
                                                        {status === 1 &&
                                                            companies.map(
                                                                (
                                                                    company,
                                                                    index
                                                                ) => (
                                                                    <li
                                                                        key={
                                                                            index
                                                                        }
                                                                        className={
                                                                            styles.companyListItem
                                                                        }
                                                                        onClick={() =>
                                                                            handleCompanyClick(
                                                                                company?.CIN ||
                                                                                "",
                                                                                company?.CompanyName
                                                                            )
                                                                        }>
                                                                        {
                                                                            company?.CompanyName
                                                                        }
                                                                    </li>
                                                                )
                                                            )}

                                                        {status == 2 &&
                                                            companies.map(
                                                                (
                                                                    company,
                                                                    index
                                                                ) => (
                                                                    <li
                                                                        key={
                                                                            index
                                                                        }
                                                                        className={
                                                                            styles.companyListItem
                                                                        }
                                                                        onClick={() =>
                                                                            handleCompanyClick(
                                                                                company.cin,
                                                                                company.entityName
                                                                            )
                                                                        }>
                                                                        <div
                                                                            className={
                                                                                styles.entityName
                                                                            }>
                                                                            {
                                                                                company.entityName
                                                                            }
                                                                        </div>
                                                                    </li>
                                                                )
                                                            )}
                                                    </>
                                                )}

                                            {!loading &&
                                                companies.length === 0 &&
                                                searchTerm.length >= 2 && (
                                                    <li>No companies found</li>
                                                )}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                    {/* moved AdvanceSearch inside the .searchBox so it positions relative to the input */}
                </div>
                {/* <button
          className={Navstyles["profile_statusbtn"]}
          type="button"
          onClick={handleLogout}
        >
          Logout
        </button> */}

                {sessionStorage.getItem("token") && (
                    <button
                        className={Navstyles["profile_statusbtn"]}
                        type="button"
                        onClick={handleLogout}>
                        Logout
                    </button>
                )}
            </div>
            <div className={Navstyles.NavItems}>
                <div className={Navstyles.navlinks}>
                    {menuItems.map((item) => (
                        <div key={item.id} className={Navstyles.items}>
                            <button
                                disabled={
                                    item.menuLink === "/kohere/Companydetails"
                                        ? CIN === ""
                                            ? true
                                            : false
                                        : null
                                }
                                onClick={() => handleNavigate(item.menuLink)}
                                className={`${Active === item.active
                                    ? Navstyles.navActive
                                    : Navstyles.navInactive
                                    } ${item.menuLink ===
                                        "/kohere/Companydetails" && CIN === ""
                                        ? Navstyles.disabled
                                        : ""
                                    }`}>
                                <div className={Navstyles.icon_wrapper}>
                                    {item.icon && (
                                        <item.icon
                                            size={22}
                                            className={Navstyles.nav_icon}
                                        />
                                    )}
                                    <span className={Navstyles.icon_text}>
                                        {item.name}
                                    </span>
                                </div>
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Navbar;
